import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { api } from '@/lib/api';
import MaintenancePage from '@/pages/MaintenancePage';

interface SiteSettings {
  maintenance_mode: boolean;
  maintenance_type: string;
  maintenance_message: string;
  maintenance_pages: string[];
}

export const MaintenanceWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [settings, setSettings] = useState<SiteSettings | null>(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const data = await api.get('/data/site_settings?id=eq.default');
        if (data && data.length > 0) {
          setSettings({
            maintenance_mode: data[0].maintenance_mode,
            maintenance_type: data[0].maintenance_type,
            maintenance_message: data[0].maintenance_message,
            maintenance_pages: Array.isArray(data[0].maintenance_pages) 
              ? data[0].maintenance_pages 
              : (typeof data[0].maintenance_pages === 'string' ? JSON.parse(data[0].maintenance_pages) : []),
          });
        }
      } catch (error) {
        console.error("Failed to load global site settings", error);
      } finally {
        setLoading(false);
      }
    };
    fetchSettings();
  }, []);

  // Allow initial app render while maintenance settings are fetched in the background
  if (loading) return <>{children}</>;

  // Always allow access to admin routes
  if (location.pathname.startsWith('/admin')) {
    return <>{children}</>;
  }

  // Check if we should block the current view
  if (settings?.maintenance_mode) {
    const blockAll = settings.maintenance_pages.includes('all');
    const blockTarget = settings.maintenance_pages.includes(location.pathname);
    
    if (blockAll || blockTarget) {
      return (
        <MaintenancePage 
          type={settings.maintenance_type as any} 
          message={settings.maintenance_message} 
        />
      );
    }
  }

  return <>{children}</>;
};

export default MaintenanceWrapper;
